import { get, post, delet } from '@/core/h5/request'

// 获取用户信息
export const fetchUserInfo = async (parm) => {
    const { spaceId, userId } = parm
    return get({
        url: `/uic/web/member/detail?spaceId=${spaceId}&userId=${userId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    })
}

/// 创建文件
export const createFile = (data) => {
    const options = {
        data,
        url: `/file/api/document/new`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 创建文件夹
export const createFolder = (data) => {
    const options = {
        data,
        url: `/file/api/document/mkdir`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 获取新建菜单配置
// TODO: 联调时移除 mock 逻辑，切换为真实接口
export const getCreateMenuConfig = (data) => {
    // mock 模式：开发阶段返回模拟数据
    // if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_MOCK_MENU === 'true') {
    //     return Promise.resolve({
    //         data: [
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_DOCUMENT_FILE', resourceName: '文档', resourceLogoUrl: null, order: 1, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_EXCEL_FILE', resourceName: '表格', resourceLogoUrl: null, order: 2, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_PPT_FILE', resourceName: '演示文稿', resourceLogoUrl: null, order: 3, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_WORD_FILE', resourceName: 'office文档', resourceLogoUrl: null, order: 4, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_SMART_SHEET_FILE', resourceName: '智能表格', resourceLogoUrl: null, order: 5, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_FLOW_CHART_FILE', resourceName: '流程图', resourceLogoUrl: null, order: 6, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_MIND_FILE', resourceName: '思维导图', resourceLogoUrl: null, order: 7, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_BOARD_FILE', resourceName: '智能白板', resourceLogoUrl: null, order: 8, action: null, resourceTag: null },
    //             { menuId: 'DOCUMENT_CREATE_FILES', resourceCode: 'CREATE_FOLDER_FILE', resourceName: '文件夹', resourceLogoUrl: null, order: 9, action: null, resourceTag: null },
    //         ],
    //     })
    // }
    const options = {
        params: data,
        url: '/app/client/menus/menu-resource',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 获取最近文件列表
export const getRecentFile = (data) => {
    const options = {
        params: data,
        url: '/file/api/document/recent',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 获取我的文件列表
export const getMyFile = (data) => {
    const options = {
        params: data,
        url: '/file/api/document/list',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 获取知识库列表
export const getWikiList = (data) => {
    const options = {
        params: data,
        url: '/file/api/wiki/space',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

// 获得收藏列表
export const getStarList = (data) => {
    const options = {
        params: data,
        url: '/file/api/file/star',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

// 置顶知识库
export const starWiki = (wikiSpaceId) => {
    const options = {
        url: `/file/api/wiki/space/star/${wikiSpaceId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

// 取消置顶知识库
export const unStarWiki = (wikiSpaceId) => {
    const options = {
        url: `/file/api/wiki/space/star/${wikiSpaceId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return delet(options)
}

// 置顶知识库列表
export const fetchStarWikiList = (data) => {
    const options = {
        params: data,
        url: '/file/api/wiki/space/star',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 检查文件重名
export const checkFileName = (data) => {
    const options = {
        data: data,
        url: `/file/api/document/upload/init/name`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}